const LOCAL_STORAGE = {
  clientDailyDownloadsCount: "downloads-count",
};

module.exports = { LOCAL_STORAGE };
